<template>
    <b-container fluid class="p-0">
        <b-row class="justify-content-center">
            <b-col cols="12" v-if="!paymentHtml">
                <div class="card-preview mb-4 shadow-sm">
                    <div class="card-chip"></div>
                    <div class="card-number-display">
                        {{ formatCardNumberDisplay || '#### #### #### ####' }}
                    </div>
                    <div class="d-flex justify-content-between align-items-end mt-4">
                        <div>
                            <div class="card-label">Kart Sahibi</div>
                            <div class="card-holder-display">
                                {{ form.card_holder_name || 'AD SOYAD' }}
                            </div>
                        </div>
                        <div>
                            <div class="card-label">SKT</div>
                            <div class="expiry-display">
                                {{ form.expiry_month || 'AA' }}/{{ form.expiry_year ? form.expiry_year.toString().slice(-2) : 'YY' }}
                            </div>
                        </div>
                    </div>
                </div>
                <b-card class="shadow-sm border-0">
                    <b-form @submit.prevent="submitPayment">

                        <b-form-group label="Kart Üzerindeki İsim" label-for="card-holder">
                            <b-form-input
                                id="card-holder"
                                v-model="form.card_holder_name"
                                required
                                uppercase
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group label="Kart Numarası" label-for="card-number">
                            <b-input-group>
                                <template #prepend>
                                    <b-input-group-text><i class="fa fa-credit-card"></i></b-input-group-text>
                                </template>
                                <b-form-input
                                    id="card-number"
                                    v-mask="'#### #### #### ####'"
                                    v-model="formattedCardNumber"
                                    @input="handleCardInput"
                                    placeholder="0000 0000 0000 0000"
                                    maxlength="19"
                                    required
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>

                        <b-row>
                            <b-col cols="8">
                                <b-form-group label="Son Kullanma Tarihi">
                                    <b-row no-gutters>
                                        <b-col cols="6" class="pr-2">
                                            <b-form-select
                                                v-model="form.expiry_month"
                                                :options="months"
                                                required
                                                class="mb-2"
                                            >
                                                <template #first>
                                                    <b-form-select-option :value="null" disabled>Ay</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                        <b-col cols="6">
                                            <b-form-select
                                                v-model="form.expiry_year"
                                                :options="years"
                                                required
                                            >
                                                <template #first>
                                                    <b-form-select-option :value="null" disabled>Yıl</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                            </b-col>

                            <b-col cols="4">
                                <b-form-group label="CVV" label-for="cvv">
                                    <b-form-input
                                        id="cvv"
                                        v-model="form.cvv"
                                        placeholder="123"
                                        maxlength="3" required
                                        type="tel"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-button type="submit" variant="primary" block size="lg" :disabled="loading" class="mt-3">
                            <span v-if="loading">
                                <b-spinner label="Spinning" class="align-middle mr-2" small
                                           v-show="loading">
                                </b-spinner>
                                {{$t('processing')}}</span>
                            <span v-else>{{currencyFormat(amount)+ ' ' +$t('pay') + ' '}}</span>
                        </b-button>
                    </b-form>
                </b-card>
            </b-col>
            <b-col v-else>
                <div class="d-flex flex-column justify-content-center align-items-center h-100" v-if="paymentHtmlLoading">
                    <b-spinner variant="primary" label="Spinning"></b-spinner>
                    <p class="mt-2">
                        {{$t('loading')}}
                    </p>
                </div>
                <iframe  style="width: 100%; border: none; height: 38rem;" sandbox="allow-same-origin allow-top-navigation allow-forms allow-scripts" :srcdoc="paymentHtml" frameborder="1" id="payment-frame"></iframe>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import ProcessingButton from "@/components/elements/ProcessingButton.vue";

export default {
    components: {
        ProcessingButton
    },
    props:{
      amount:{
          type:Number,
          default:0
      },
      paymentHtml:{
          type:String,
          default:''
      },
    },
    data() {
        return {
            loading: false,
            paymentHtmlLoading:false,
            formattedCardNumber: '',
            form: {
                card_holder_name: '',
                card_number: '',
                expiry_month: null,
                expiry_year: null,
                cvv: ''
            },
            months: [
                { value: '01', text: '01' },
                { value: '02', text: '02' },
                { value: '03', text: '03' },
                { value: '04', text: '04' },
                { value: '05', text: '05' },
                { value: '06', text: '06' },
                { value: '07', text: '07' },
                { value: '08', text: '08' },
                { value: '09', text: '09' },
                { value: '10', text: '10' },
                { value: '11', text: '11' },
                { value: '12', text: '12' },
            ]
        };
    },
    computed: {
        years() {
            const currentYear = new Date().getFullYear();
            const years = [];
            for (let i = 0; i < 12; i++) {
                years.push(currentYear + i);
            }
            return years;
        },
        formatCardNumberDisplay() {
            return this.formattedCardNumber;
        }
    },
    watch: {
        'form.card_holder_name'(val) {
            this.form.card_holder_name = val.toUpperCase();
        },
        'paymentHtml'(val){
            if (val!==''){
                this.paymentHtmlLoading=true
                setTimeout(()=>{
                    this.paymentHtmlLoading=false
                },500)
            }
        }

    },
    methods: {
        handleCardInput(val) {
            let rawValue = val.replace(/\D/g, '');
            this.form.card_number = rawValue;
            let formatted = rawValue.match(/.{1,4}/g);
            this.formattedCardNumber = formatted ? formatted.join(' ') : '';
        },
        submitPayment() {
            if (this.form.card_number.length < 16) {
                this.$toast.error(this.$t('valid_cart'))
                return;
            }
            this.$emit('payment-success', this.form);
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 3000);
        }
    }
};
</script>

<style scoped>
.card-preview {
    background: linear-gradient(135deg, #4b6cb7 0%, #182848 100%);
    border-radius: 15px;
    padding: 20px;
    color: white;
    height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    font-family: 'Courier New', Courier, monospace; /* Kart fontu */
}
.card-chip {
    width: 50px;
    height: 35px;
    background: linear-gradient(135deg, #ffd700 0%, #d4af37 100%);
    border-radius: 5px;
    margin-bottom: 10px;
}

.card-number-display {
    font-size: 1.4rem;
    letter-spacing: 2px;
    text-shadow: 0 1px 2px rgba(0,0,0,0.6);
}

.card-label {
    font-size: 0.7rem;
    text-transform: uppercase;
    opacity: 0.8;
}

.card-holder-display, .expiry-display {
    font-size: 1rem;
    font-weight: bold;
    text-transform: uppercase;
}
</style>
